import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss'],
})
export class FilterTagComponent {
  @Input() id: number;
  @Input() value: string;
  @Output() deleteItem: EventEmitter<number> = new EventEmitter<number>();

  delete(id: number) {
    this.deleteItem.emit(id);
  }
}
